module.exports = "https://99designs-start-assets.imgix.net/js/2d83a0e121632da55e61e4d981dbd754.png";